module.exports = __webpack_public_path__ + "static/media/logo-cf-white.9b3646f7.svg";